export const createDownload = (url: string, fname?: string) => {
  let filename = fname;
  if (!filename) {
    try {
      filename = url.split(/[?#]/)[0].split('/').slice(-1)[0]
    } catch {
      filename = 'download';
    }
  }

  const a = document.createElement('a');
  a.download = filename;
  a.href = url;
  a.target = '_blank';
  a.click();
};

export const asyncDownload = async (url: string, fname?: string) => {
  try {
    await fetch(url.replace(/^http:/, 'https:')).then((res) => res.blob()).then((blob) => {
      createDownload(URL.createObjectURL(blob), fname);
    });
  } catch  {
    createDownload(`${url.replace(/^http:/, 'https:')}?response-content-type=application/octet-stream`, fname);
  }
};
